import { getSnapshot, subscribe, type TFlagSnapshot } from "@lib/feature-flags";
import { useEffect } from "react";
import { register } from "../utils";

export const buildFlagProperties = (
  snapshot: TFlagSnapshot,
): Record<string, unknown> => {
  const properties: Record<string, unknown> = {};
  const active: string[] = [];
  for (const name of Object.keys(snapshot)) {
    const { on } = snapshot[name];
    properties[`feature flag: ${name}`] = on;
    if (on) active.push(name);
  }
  properties["active feature flags"] = active;
  return properties;
};

export const useRegisterFeatureFlags = (authenticated = false): void => {
  useEffect(() => {
    if (!authenticated) return;
    const registerFlags = () => register(buildFlagProperties(getSnapshot()));
    registerFlags(); // flags may already be resolved
    const unsubscribe = subscribe(registerFlags); // re-register when they land / on org switch
    return unsubscribe;
  }, [authenticated]);
};
